import { render, staticRenderFns } from "./ModelPopUp.vue?vue&type=template&id=2df68c4e&"
import script from "./ModelPopUp.vue?vue&type=script&lang=js&"
export * from "./ModelPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ModelPopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports